var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTier2 = function SvgTier2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tier-2_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30,
    stroke: "#F5A524",
    vectorEffect: "non-scaling-stroke"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tier-2_svg__b)",
    d: "M38.867 48.816a2.14 2.14 0 0 0 .002 2.401l9.351 13.826c.865 1.279 2.766 1.276 3.627-.006l9.288-13.826a2.14 2.14 0 0 0 .001-2.389l-9.288-13.857c-.86-1.284-2.764-1.287-3.63-.006l-9.35 13.857Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tier-2_svg__b",
    x1: 62.283,
    x2: 34.666,
    y1: 58.992,
    y2: 50.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5A524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDEDD3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tier-2_svg__a",
    width: 100,
    height: 100,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.960784 0 0 0 0 0.647059 0 0 0 0 0.141176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_610_997"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_610_997",
    result: "shape"
  })))));
};
export default SvgTier2;